import React, { useCallback } from 'react';
import { FormikHelpers } from 'formik';
import { useNavigate } from 'react-router';

import Page from '../../../components/Page';
import AuthShell from '../../../components/ui/AuthShell';
import RecoverPasswordForm, { IRecoverPasswordValues } from './recoverPasswordForm';
import { handlePromise } from '../../../utils/handlePromisse';
import { recoverPassword } from '../../../services/authService';
import { useModal } from '../../../contexts/modal';
import MCAlert from '../../../components/ModalContents/MCAlert';

const RecoverPassword: React.FC = () => {

  const { setModalContent, setModalOpen } = useModal()
  const navigate = useNavigate()
  const onSubmit = useCallback(async (values: IRecoverPasswordValues, actions: FormikHelpers<IRecoverPasswordValues>) => {
    if (!values.email) {
      setModalContent(
        <MCAlert
          title="Impossível continuar!" text="Por favor informe um email."
          onClose={() => setModalOpen(false)}
        />
      )
      setModalOpen(true)
      return
    }
    const [ result, error ] = await handlePromise(recoverPassword(values.email))
    if(error){
      console.log(error)
      setModalContent(
        <MCAlert
          title="Erro ao recuperar senha!" text="Um erro ocorreu, tente novamente mais tarde."
          onClose={() => setModalOpen(false)}
        />
      )
      setModalOpen(true)
      return
    }
    if (result.status === 500) {
      setModalContent(
        <MCAlert
          title="Erro ao recuperar senha!" text="Um erro interno ocorreu, tente novamente mais tarde."
          onClose={() => setModalOpen(false)}
        />
      )
      setModalOpen(true)
      return
    }
    setModalContent(
      <MCAlert
        title="Enviamos um email pra você!"
        text={`Verifique o email que foi enviado para "${values.email}" e clique no link de recuperação de senha.`}
        onClose={() => {
          setModalOpen(false)
          navigate('/login')
        }}
      />
    )
    setModalOpen(true)
  }, [ setModalContent, setModalOpen, navigate ])

  return (
    <Page title="Recover Password | ProAtivos">
      <AuthShell
        kicker="Redefinição"
        title="Recuperar senha"
        panelBadge={null}
        panelHeadline="Esqueceu a senha? Sem problema."
        panelText="Enviamos um link seguro para você criar uma nova senha em segundos."
        subtitle="Informe o e-mail da sua conta e enviaremos um link para redefinir a senha."
      >
        <RecoverPasswordForm handleSubmitProp={onSubmit}/>
      </AuthShell>
    </Page>
  )
}

export default RecoverPassword
